// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","644":"86e4f369","732":"4462740c"}[chunkId] + ".chunk.js";
};